import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('basic-slider', () => import(/* webpackMode: "lazy" */'./basic-slider'));
